<script>
export default {
  name: "InputFile",
  data(){
    return{
      file:{
        name: "Choose file...",
        content:null
      },
      browse_text:"Browse",
      addDocumentText:'Add Document'
    }
  },
  model: {
    prop: 'checked',
    event: 'file'
  },
  props:{
    size:{
      type:String,
      required: false,
      default: 'md', // Default size
      validator: value => ['sm', 'md'].includes(value)
    },
    checked:[Object,File,Array],
    isInputFile:{
      type:Boolean,
      default:true
    }
  },
  methods:{
    triggerFileInput(){
      $("#file-output").click();
    },
    handleFileUpload(e){
      const file = e.target.files[0];
      this.file.name = file.name;
      this.file.content = file;
      this.$emit('file', file);

    },
    resetFile(){
      this.file = {
        name:"Choose file...",
        content:null
      }
    },

  },
  computed:{
    inputSize(){
      return `file-display-height-${this.$props.size}`;
    },
  },
  watch: {
    checked: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) {
          this.resetFile();
        }
      }
    }
  }
}
</script>

<template>
  <div class="file-container position-relative" >
    <input  type="file" id="file-output" accept=".pdf"  style="display:none;" @change="handleFileUpload">
    <div class="file-inputs " v-if="isInputFile" >
      <span class="file-name ellipsis " @click="triggerFileInput">{{ file.name }}</span>
      <input type="text" class="file-display form-control"  style="text-align: left !important;" :class="inputSize"  readonly>
<!--      <button type="button" class="file-btn btn" :class="inputSize" @click="resetFile" :hidden="file.content === null">Reset</button>-->
      <button type="button" class="file-btn btn" :class="inputSize"  @click="triggerFileInput" >Browse</button>
    </div>
    <div v-else>
      <div class="d-flex flex-column">
        <div >
          <button class="e-btn e-btn-green px-3" type="button"  @click="triggerFileInput">
        <span v-if="!file.content" class="e-text-white">
          <font-awesome-icon icon="plus" class="e-text-white" />
          Add Document
        </span>
            <span v-else  class="e-text-white">
           <font-awesome-icon icon="folder-plus" class="e-text-white" />
          Replace Document
        </span>
          </button>

        </div>
        <div style="display:flex;align-items:center; padding-left:20px; " >
          <div style=" width:90% !important;"  v-if="file.content" >
            <ul >
              <li >
                <div class="ellipsis">
                  <span class="e-text-black " style="width:auto !important; ">{{ file.name }}</span>

                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<style scoped>
.file-name{
  position: absolute;
  top:5px;
  left:10px;
  font-size:.8rem;
  width:77%;
}
.ellipsis{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
input,
button{
  display: flex;
  justify-content: center;
  align-items: center;
}
button:hover,
button:focus,
button:active,
button:visited {
  outline: none !important;
  box-shadow: none !important;
}
.file-inputs{
  position: relative;
  cursor: pointer;
}
.file-btn{
  position: absolute;
  right:0;
  top:0;
  border:1px solid #ced4da;
  background-color: white;
  width:20.5%;
}
.file-display-height-sm{ height:30px; }
.file-display-height-md { height:40px; }
.file-display:read-only{
  background-color: white;
}
.file-display{
  width:80%;
}
.file-container{
  height:50px;
}
</style>
